import * as Request from '../../request'
import * as Constants from './constants'
import * as Types from './types'
import * as Utils from './utils'

export const fetchSingleSource =
  (community: string, sourceId: Types.SourceId) =>
    Request.requestActionCreator<Types.FetchSourceConfigPayload>(Constants.FETCH_SOURCE)
    ({url: `${Constants.SERVER_RESOURCE}/${community}/${sourceId}`, method: 'GET', sourceId})

type SelectSourceActionCreator = (sourceId: Types.SourceId) => Types.SelectSourceAction

export const selectSource: SelectSourceActionCreator =
  (sourceId: Types.SourceId) => ({ type: Constants.SELECT_SOURCE, sourceId })

export const resetSource: Types.ResetSource = () => {
  return { payload: {}, type: Constants.RESET_SOURCE }
}

export const updateSource: Types.UpdateSource = (community: string, source: Types.SelectedSource) => {
  return Request.requestActionCreator<Types.SubmitOptions>(Constants.UPDATE_SOURCE_SUBMIT)
    ({
      method: 'PUT',
      payload: Utils.asSubmitPayload(source),
      url: `${Constants.SERVER_RESOURCE}/${community}/${source.id}`,
    })
}

export const updateField: Types.UpdateField = (field: Types.FieldChange) =>
  ({type: Constants.UPDATE_SOURCE_FIELD, field})



// WEBPACK FOOTER //
// ./src/pages/source-config/actions.ts